import React, { createContext, useState, useEffect, useContext } from 'react';

export const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const getInitialCurrencySymbol = () => {
    try {
      const storedSymbol = localStorage.getItem('currencySymbol');
      return storedSymbol ? JSON.parse(storedSymbol) : '₹'; // Default to Rupees
    } catch (error) {
      console.error("Failed to parse currency symbol from localStorage", error);
      return '₹'; // Fallback default
    }
  };

  const [currencySymbol, setCurrencySymbol] = useState(getInitialCurrencySymbol);

  useEffect(() => {
    try {
      localStorage.setItem('currencySymbol', JSON.stringify(currencySymbol));
    } catch (error) {
      console.error("Failed to save currency symbol to localStorage", error);
    }
  }, [currencySymbol]);

  const value = {
    currencySymbol,
    setCurrencySymbol,
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

// Custom hook for convenience
export const useCurrency = () => {
  return useContext(CurrencyContext);
};
